// extracted by mini-css-extract-plugin
module.exports = {"form":"LoginPage_form__kgOTe","nav":"LoginPage_nav__2_GAU","primary":"LoginPage_primary__3SM9V","button":"LoginPage_button__1iM4H"};